import { ALLOWED_EXTERNAL_DOMAINS } from "../../constants/allowedExternalDomains";
import { FIRM_PATH } from "../../constants/storageKeys";

export function getNavigationUrl(path: string) {
  const firmPath = localStorage.getItem(FIRM_PATH) || "";
  const safePathPrefix = firmPath ? "/" + firmPath : "";
  const defaultPath = `${safePathPrefix}/dashboard`;

  // 1. Girdi yoksa veya bir string değilse varsayılana dön
  if (!path || typeof path !== 'string') {
    return defaultPath;
  }

  // 2. Tam URL'leri kontrol et
  try {
    const maybeUrl = new URL(path);
    const hostname = maybeUrl.hostname.toLowerCase();

    // Sadece izin verilen dış domainlere izin ver
    if (ALLOWED_EXTERNAL_DOMAINS.includes(hostname)) {
      // Yalnızca https şemasına izin ver
      if (maybeUrl.protocol === 'https:') {
        return path;
      }
    }
    
    // Güvenli olmayan şema veya izin verilmeyen domain, engelle ve console'a uyarı bas
    console.warn("Blocked external or unsafe navigation attempt!");
    return defaultPath;

  } catch (err) {
    
  }

  // 3. Path Kontrolü
  const lower = path.toLowerCase();

  // Şüpheli şemaları tekrar kontrol et. (URL parser'ı atlatma ihtimaline karşı)
  if (
    lower.startsWith("javascript:") || 
    lower.startsWith("data:") ||
    lower.startsWith("file:")
  ) {
    console.warn("Blocked unsafe relative path attempt (protocol)!");
    return defaultPath;
  }

  // Internal path için yalnızca '/' ile başlayan path'lere izin ver
  if (!path.startsWith('/')) {
      console.warn("Blocked unsafe relative path attempt (not starting with /)!");
      return defaultPath; 
  }
  
  // 4. URL Normalize Etme ve Manipülasyon Engeli
  let safePath = path;

  try {
      // Göreceli path'i mevcut orijin ile birleştirerek güvenli hale getir
      const url = new URL(safePath, window.location.origin);
      
      // Oluşan URL'nin orijini, mevcut orijinle aynı değilse engelle ve console'a uyarı bas.
      if (url.origin !== window.location.origin) {
        console.warn("Blocked origin manipulation attempt!");
        return defaultPath;
      }
      
      // Normalize edilmiş path ve query string'i al
      safePath = url.pathname + url.search;
  } catch {
    return defaultPath;
  }

  // Güvenli, internal yönlendirmeyi döndür
  return `${safePathPrefix}${safePath}`;
}